<div class="form-guests">
  <div class="form-guests__title">
    <h4><i class="icon-group-people"></i> Ospiti</h4>
  </div>
  <div class="form-guests__item">
    <form name="guestsForm">
      <div class="form-guests__group">
        <div class="form-group">
          <div class="quotation-guests__selection">
            <label class="col-form-label quotation-guests__label">Adulti</label>
            <div class="spinner-counter">
              <span class="spinner-counter__btn" (click)="removeAdult()">
                <i class="icon-minus" ></i>
              </span>
              <span class="spinner-counter__count">{{passengers.adultsNum}}</span>
              <span class="spinner-counter__btn" (click)="addAdult()">
                <i class="icon-plus"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="quotation-guests__selection">
            <label class="col-form-label quotation-guests__label">Bambini</label>
            <div class="spinner-counter">
              <span class="spinner-counter__btn" (click)="removeChild()">
                <i class="icon-minus" ></i>
              </span>
              <span class="spinner-counter__count">{{passengers.childrenNum}}</span>
              <span class="spinner-counter__btn" (click)="addChild()">
                <i class="icon-plus"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="passengers.childrenNum > 0">
          <div class="quotation-guests__content">
            <label class="col-form-label quotation-guests__label">Inserisci la data di nascita dei bambini</label>
            <div class="quotation-guests__group">
              <div class="quotation-guests__age age-section">
                <div class="form-row row">
                  <div class="form-group-custom mb-1 col-12 col-lg-6"  *ngFor="let childAge of passengers.childrenAges; trackBy: trackByIdx; let i = index">
                    <input type="date" name="chldAge" placeholder="gg/mm/aaaa" [(ngModel)]="passengers.childrenAges[i]">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button (click)="confirm()" class="btn btn&#45;&#45;orange">Conferma</button>
    </form>
  </div>
</div>


<!--
<div>
  <div>
    Adulti
    <button (click)="removeAdult()">-</button>
    {{passengers.adultsNum}}
    <button (click)="addAdult()">+</button>
  </div>
</div>

<div>
  <div>
    Bambini
    <button (click)="removeChild()">-</button>
    {{passengers.childrenNum}}
    <button (click)="addChild()">+</button>
  </div>
  <div>
    <div *ngFor="let childAge of passengers.childrenAges; trackBy: trackByIdx; let i = index">
      <input type="date" [(ngModel)]="passengers.childrenAges[i]">
    </div>
  </div>
</div>

<div>
  <button (click)="confirm()">Conferma</button>
</div>

-->
